export default __webpack_public_path__ + "0aa66614bd41045fc564afa49a435220.woff2";